<template>
  <div class="wrapper">
    <!-- <Header /> -->
    <router-view />
  </div>
</template>
<script>
// import Header from '../../components/Header/Header'

export default {
  name: "Wrapper",
  components: {
    // Header
  },
  props: [],
  data() {
    return {
      collapsed: false
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>
<style src="./Wrapper.scss" scoped lang="scss"></style>
